<template>
    <div class="text-center">
        <!-- Loading -->
        <div v-if="loading" class="col-12 text-center py-2">
          <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
          <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
          <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
        </div>
        <!-- End Loading -->
				<div class="table-responsive async-tables mt-2 text-center" v-if="showHtmlTable">
          <b-table  
            show-empty
            hover
            small
            bordered
            stacked-sm
            :items="table.body" 
            :fields="selectedColumnsObjs"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            selectable
            select-mode="multi"
            :tbody-tr-class="rowClass"
            @row-clicked="item=>onRowSelected(item)"
            id="spit-revenue-table">

              <!-- A virtual column -->
              <template #cell(index)="data">
                <div :class="expedia(data.item.name) + ' text-left'">
                  
                  
                  <a v-if="data.item.row_data.type != '_source'" 
                      href="#" @click="showComparativeModal(data)">
                      {{ data.item.name }}
                  </a>
                  <span v-else>{{ data.item.name }}</span>

                  <md-icon 
                    icon="star"
                    class="text-warning font-weight-bolder"
                    style="font-size: 12px; padding-bottom: 2px;"
                    v-if="data.item.star == true"
                    />
                  <template v-if="data.item.row_data.type != 'source'">
                    <md-icon v-if="data.rowSelected"
                    icon="keyboard_arrow_down"
                    class="text-secondary font-weight-bolder"/>
                    <md-icon v-else
                    icon="keyboard_arrow_right"
                    class="text-secondary font-weight-bolder"/>
                  </template>
                  <div class="text-muted"><small>{{ data.item.domain }}</small></div>
                </div>
              </template>

              <!-- A virtual column -->
              <template #cell(spit_rides)="data">
                <div class="text-right">
                  {{ number_format(data.item.spit_rides,0,'.',',') }}
                  <md-icon 
                    icon="arrow_upward"
                    class="text-success font-weight-bolder"
                    v-if="data.item.spit_rides > data.item.last_year_spit_rides"/>
                  <md-icon v-else
                    icon="keyboard_double_arrow_down"
                    class="text-danger font-weight-bolder"/>
                </div>
              </template>

              <!-- A virtual column -->
              <template #cell(last_year_spit_rides)="data">
                <div class="text-right">
                  {{ number_format(data.item.last_year_spit_rides,0,'.',',') }}
                </div>
              </template>

              <!-- A virtual column -->
              <template #cell(rides)="data">
                <div class="text-right">
                  <a href="#" @click="showTimeLineModal(data)">
                    {{ number_format(data.item.rides,0,'.',',') }}
                  </a>
                  <md-icon 
                    icon="arrow_upward"
                    class="text-success font-weight-bolder"
                    v-if="data.item.rides > data.item.last_year_rides"/>
                  <md-icon v-else
                    icon="keyboard_double_arrow_down"
                    class="text-danger font-weight-bolder"/>
                </div>
              </template>

              <!-- A virtual column -->
              <template #cell(last_year_rides)="data">
                <div class="text-right">
                  {{ number_format(data.item.last_year_rides,0,'.',',') }}
                </div>
              </template>

              <!-- A virtual column -->
              <template #cell(spit_total)="data">
                <div class="text-right">
                  <span v-b-tooltip.hover :title=data.item.spit_total>
                    ${{ formatNumberString(data.item.spit_total) }}
                  </span>
                  <md-icon 
                    icon="arrow_upward"
                    class="text-success font-weight-bolder"
                    v-if="data.item.spit_total > data.item.last_year_spit_total"/>
                  <md-icon v-else
                    icon="keyboard_double_arrow_down"
                    class="text-danger font-weight-bolder"/>
                </div>
              </template>

              <!-- A virtual column -->
              <template #cell(last_year_spit_total)="data">
                <div class="text-right">
                  <span v-b-tooltip.hover :title=data.item.last_year_spit_total>
                    ${{ formatNumberString(data.item.last_year_spit_total) }}
                  </span>
                </div>
              </template>

              <!-- A virtual column -->
              <template #cell(total)="data">
                <div class="text-right">
                  <span v-b-tooltip.hover :title=data.item.total>
                    ${{ formatNumberString(data.item.total) }}
                  </span>
                  <md-icon 
                    icon="arrow_upward"
                    class="text-success font-weight-bolder"
                    v-if="data.item.total > data.item.last_year_total"/>
                  <md-icon v-else
                    icon="keyboard_double_arrow_down"
                    class="text-danger font-weight-bolder"/>
                </div>
              </template>

               <!-- A virtual column -->
               <template #cell(last_year_total)="data">
                <div class="text-right">
                  <span v-b-tooltip.hover :title=data.item.last_year_total>
                    ${{ formatNumberString(data.item.last_year_total) }}
                  </span>
                </div>
              </template>

              <!-- A virtual column -->
              <template #cell(supplier_cost)="data">
                <div class="text-right">
                  <span v-b-tooltip.hover :title=data.item.supplier_cost>
                    ${{ formatNumberString(data.item.supplier_cost) }}
                  </span>
                </div>
              </template>

              <!-- A virtual column -->
              <template #cell(profit)="data">
                <div class="text-right">
                  <span v-b-tooltip.hover :title=data.item.profit>
                    ${{ formatNumberString(data.item.profit) }}
                  </span>
                  <md-icon 
                    icon="arrow_upward"
                    class="text-success font-weight-bolder"
                    v-if="data.item.profit > data.item.last_year_profit"/>
                  <md-icon v-else
                    icon="keyboard_double_arrow_down"
                    class="text-danger font-weight-bolder"/>
                </div>
              </template>

              <!-- A virtual column -->
              <template #cell(margin_profit)="data">
                <div class="text-right">
                  <span 
                    v-b-tooltip.hover :title=data.item.margin_profit 
                    :class="getTextColorPercentage(data.item.margin_profit)">
                    {{ (data.item.margin_profit) }}%
                  </span>
                </div>
              </template>

              <template #row-details="row">
                <div class="ml-2">
                  <TableComponent 
                    :ref="'table'+row.item.index" 
                    :scale="scale"
                    :columns="columns"
                    @show-time-line="showTimeLine"
                    @show-comparative="showComparative">
                  </TableComponent>
                </div>
              </template>
          </b-table>
        </div>
    </div>
</template>

<script>
  import api from '../../../../api'

  export default {
    name: "TableComponent",
    props: ['scale', 'columns'],
    data() {
      return {
        sortBy: 'index',
        sortDesc: true,
        codeReport: 'spit-revenue',
        loading: true,
        showHtmlTable: false,
        filters: {},
        table: {
          header: [
            {
              key: 'index',
              label: 'Indice',
              sortable: true
            },
            {
              key: 'spit_rides',
              label: 'SPIT Rides',
              sortable: true,
              variant: 'info'
            },
            {
              key: 'last_year_spit_rides',
              label: 'SPIT Rides P.A.',
              sortable: true,
              variant: 'info'
            },
            {
              key: 'rides',
              label: 'Rides',
              sortable: true,
              variant: 'info'
            },
            {
              key: 'last_year_rides',
              label: 'Rides P.A.',
              sortable: true,
              variant: 'info'
            },
            {
              key: 'spit_total',
              label: 'SPIT Total',
              sortable: true,
              variant: 'warning'
            },
            {
              key: 'last_year_spit_total',
              label: 'SPIT Total P.A',
              sortable: true,
              variant: 'warning'
            },
            {
              key: 'total',
              label: 'Total',
              sortable: true,
              variant: 'warning'
            },
            {
              key: 'last_year_total',
              label: 'Total P.A.',
              sortable: true,
              variant: 'warning'
            },
            {
              key: 'supplier_cost',
              label: 'Proveedor',
              sortable: true,
              variant: 'primary'
            },
            {
              key: 'profit',
              label: 'Ganancia',
              sortable: true,
              variant: 'success'
            },
            {
              key: 'margin_profit',
              label: 'Margen',
              sortable: true
            },
          ],
          body: []
        },
        data: null,
        dataComparative: null
      }
    },
    methods: {
      loadTable(filters, scale) {
        this.scale   = scale
        this.filters = filters

        this.fetchData(filters)
      },
      fetchData(filters) {
        api(this).get(`/reports/${this.codeReport}`, {
          params: {filters}
        }).then(res => {
          this.showHtmlTable = true

          let data = res.data.body;
          let body = []
          for (const group in data) {
            let name = (String) (data[group].name)  // '500' name exception
            data[group].name = name.substring(0, 40);
            body.push(data[group])
          }

          this.table.body = body
        })
        .catch(error => {
          this.$root.handleRequestError(error);
        })
        .finally(() => {
          this.loading = false;
        });
      },
      onRowSelected(item) {
        if (item.row_data.type == 'source') {
          console.log('Se dio click a criterio de agrupación canal, proveedor o punto de venta');
          return false
        }

        this.$set(item, '_showDetails', !item._showDetails)
        this.$nextTick(() => {
          if (item._showDetails) {
            const childComponent = this.$refs['table'+item.index];
            if (childComponent) {
              this.filters.row_data = item.row_data
              childComponent.loadTable(this.filters, this.scale)
            } else {
              console.error('Table Child component reference is undefined.');
            }
          }
        })
      },
      rowClass(item) {
        if (item != 'undefined') {
          if (item.profit < 0) {
            return 'table-danger'
          }
        }
      },
      formatNumberString(number) {
        if (this.scale == true) {
          /** 1 M */
          const scaleMillions = 1000000
          if (number >= scaleMillions) {
            number = this.number_format((number/scaleMillions),2,'.',',');
            return number + " M";
          }
          /** 100 K */
          const scaleThousands = 1000
          if (number >= 100000) {
            number = this.number_format((number/scaleThousands),2,'.',',');
            return number + " k";
          }
        }

        return this.number_format(number,2,'.',',');
      },
      number_format (number, decimals, dec_point, thousands_sep) {
        // Strip all characters but numerical ones.
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number,
        prec  = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep   = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec   = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s     = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
        
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
          s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }

        if ((s[1] || '').length < prec) {
          s[1] = s[1] || '';
          s[1] += new Array(prec - s[1].length + 1).join('0');
        }

        return s.join(dec);
      },
      getTextColorPercentage(quantity) {
        let variant = ''
        if (quantity >= 20) {
          variant = 'text-success font-weight-bold'
        } else {
          variant = 'text-warning font-weight-bold'
        }

        return variant + ' text-right'
      },
      expedia(name) {
        if (name.includes('Expedia')) return 'bg-warning'
        return ''
      },
      showTimeLineModal(data) {
        this.data = data
        this.$emit('show-time-line', data);
      },
      showTimeLine(data) {
        this.$emit('show-time-line', data);
      },
      showComparativeModal(data) {
        this.dataComparative = data;
        this.$emit('show-comparative', data);
      },
      showComparative(data) {
        this.$emit('show-comparative', data);
      }
    },
    computed: {
      selectedColumnsObjs() {
        return this.table.header.filter(
          column => this.columns.indexOf(column.key) !== -1
        );
      }
    }
  }

</script>